import {ConfigMigrationAnalyticsAction} from 'constants/AnalyticsConstants';

import {BaseConfigMigrationEventMetadata, trackConfigMigrationEvent} from './CommonConfigMigrationAnalytics';

/**
 * Track when a user clicks the "Return to old migration experience" button.
 */
export function trackClickedOldMigrationExperience(metadata: BaseConfigMigrationEventMetadata): void {
  trackConfigMigrationEvent(ConfigMigrationAnalyticsAction.CLICKED_OLD_MIGRATION_EXPERIENCE, metadata);
}

/**
 * Track when a user clicks the "Try the new migration experience" button.
 */
export function trackClickedNewMigrationExperience(metadata: BaseConfigMigrationEventMetadata): void {
  trackConfigMigrationEvent(ConfigMigrationAnalyticsAction.CLICKED_NEW_MIGRATION_EXPERIENCE, metadata);
}
